import {
  SCRIPT_BLOCKED_TYPE,
  SCRIPT_TYPE,
} from 'constants/elementTypes'


/**
 * Takes off the marks the AutoBlocker itself left on `node`.
 *
 * Some pages point one element at several addresses in turn, and every mark
 * here describes the address that was current when it was made. Left in place
 * they answer for the next address, which they know nothing about.
 *
 * Only our own marks come off. `Image.prototype` is patched for every image on
 * the page, so this runs for elements we have never touched, and the site's
 * `data-src`, a hand-written `data-categories`, and a hand-written
 * non-executable `type` all have to survive it.
 *
 * @param {Element} node
 */
export default function clearAutoBlocking(node) {
  if ( node.dataset.hasDerivedCategories ) {
    node.removeAttribute('data-categories')
    node.removeAttribute('data-has-derived-categories')
  }

  if ( !node.dataset.autoblocked ) {
    return
  }

  node.removeAttribute('data-autoblocked')
  node.removeAttribute('data-src')

  if ( node.getAttribute('type') === SCRIPT_BLOCKED_TYPE ) {
    node.setAttribute('type', SCRIPT_TYPE)
  }
}
